import AgenciesHeader from '../AgenciesHeader';
import AgenciesFilterBar from '../AgenciesFilterBar';
import AgenciesList from '../AgenciesList';

import styles from './AgenciesSummary.module.scss';

const AgenciesSummary = () => (
  <div className={styles.agenciesSummaryContainer}>
    <div className={styles.headerContainer}>
      <AgenciesHeader />
      <AgenciesFilterBar />
    </div>
    <AgenciesList />
  </div>
);

export default AgenciesSummary;
